const url = 'admin.lousautreau.com';

const endpoints = {
  home: `https://${url}/wp-json/acf/v3/pages/11`,
  about: `https://${url}/wp-json/acf/v3/pages/22`,
  projects: `https://${url}/wp-json/acf/v3/posts/`,
};

export { endpoints }; /* eslint-disable-line */
